
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Bestpicnicspotnearakola() {



  const cardData =
  {
    keyword: ' Best Picnic Spot Near Akola',
    heading:  'Woodland Escape: Best Picnic Spot Near Akola',
    headingDescription: 'Woodland Escape Resort, one of the best picnic spots near Akola, offers a serene and scenic retreat surrounded by lush greenery, gentle streams, and forested landscapes — perfect for a refreshing day out with family or friends. Located just a comfortable drive from Akola, the resort provides an ideal mix of relaxation and recreation, featuring open picnic lawns, adventure activities, nature trails, and a swimming pool to make your outing truly memorable. Guests can enjoy delicious local and multi-cuisine meals, unwind in cozy outdoor seating areas, or explore the natural surroundings for a rejuvenating escape from the city’s hustle. Whether it’s a casual family picnic, a friends’ getaway, or a team outing, Woodland Escape Resort near Akola promises a perfect blend of comfort, fun, and nature — making it the ultimate destination for a delightful picnic experience.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



 "services": [
    {
      "name": "Best Picnic Spot Near Akola",
      "description": "Woodland Escape Resort is recognized as the best picnic spot near Akola, offering a beautiful natural environment with lush greenery, open spaces, and fun-filled activities. Families and groups can enjoy games, nature walks, and delicious local cuisine while relaxing in a peaceful countryside atmosphere."
    },
    {
      "name": "Akola Top Picnic Places",
      "description": "Among the top picnic places near Akola, Woodland Escape Resort stands out for its scenic beauty, family-friendly amenities, and engaging activities. It’s an ideal location for day outings, featuring picnic setups, adventure zones, and serene landscapes for relaxation and enjoyment."
    },
    {
      "name": "Akola Family Picnic Spot",
      "description": "Woodland Escape Resort is the perfect family picnic spot near Akola, designed for all age groups to have fun together. Families can spend the day exploring nature, enjoying outdoor games, and sharing quality time over a picnic lunch in the tranquil surroundings."
    },
    {
      "name": "Akola Outdoor Picnic Spot",
      "description": "If you’re looking for an outdoor picnic spot near Akola, Woodland Escape Resort provides the perfect setting. Surrounded by greenery and open air, the resort offers guests plenty of outdoor activities, sports, and scenic picnic areas ideal for groups and families."
    },
    {
      "name": "Affordable Picnic Spot Akola",
      "description": "Woodland Escape Resort offers an affordable picnic spot option near Akola without compromising on fun or comfort. With budget-friendly packages that include meals, games, and access to open picnic areas, it’s a great choice for families and school groups."
    },
    {
      "name": "Akola Weekend Picnic",
      "description": "Plan your Akola weekend picnic at Woodland Escape Resort and enjoy a refreshing getaway. The resort offers both one-day and weekend options filled with nature experiences, recreational activities, and peaceful surroundings — perfect for unwinding from the city routine."
    },
    {
      "name": "Akola Nature Picnic Spot",
      "description": "For nature lovers, Woodland Escape Resort is a must-visit nature picnic spot near Akola. The resort is surrounded by trees, open fields, and serene landscapes where visitors can connect with nature, take long walks, and relax in a calm environment."
    },
    {
      "name": "Akola Park Picnic Spot",
      "description": "Woodland Escape Resort functions as a park-style picnic spot near Akola, complete with gardens, play zones, and shaded resting areas. Families and kids can play, eat, and explore the beautiful outdoors — all in a safe and refreshing atmosphere."
    },
    {
      "name": "Akola Riverside Picnic Spot",
      "description": "Enjoy a riverside picnic experience near Akola at Woodland Escape Resort. The gentle flow of nearby water, combined with green landscapes, creates the perfect picnic atmosphere. Guests can enjoy outdoor games and meals while relaxing by nature’s side."
    },
    {
      "name": "Akola Garden Picnic Spot",
      "description": "Woodland Escape Resort features well-maintained garden areas ideal for picnics near Akola. Visitors can set up picnic mats, enjoy meals among blooming plants, and participate in outdoor games, making it a wonderful location for both families and couples."
    },
    {
      "name": "Akola Hill Picnic Spot",
      "description": "Located near scenic elevations, Woodland Escape Resort serves as a hill picnic spot near Akola. The mild slopes and panoramic views make it perfect for photography, peaceful walks, and relaxing with friends and family in a picturesque environment."
    },
    {
      "name": "Akola Kids Friendly Picnic Spot",
      "description": "Woodland Escape Resort is a kids-friendly picnic spot near Akola that offers safe play areas, fun outdoor activities, and ample open spaces for children to run around freely. Families can relax while kids enjoy games, animal interactions, and nature exploration."
    },
    {
      "name": "Akola Picnic Spot Booking",
      "description": "Book your Akola picnic experience at Woodland Escape Resort easily through their convenient booking service. Choose from one-day packages that include meals, activity access, and reserved picnic spaces for an organized and enjoyable outing."
    },
    {
      "name": "Akola Picnic Tour Packages",
      "description": "Woodland Escape Resort offers picnic tour packages near Akola that include transportation options, meals, and access to all resort facilities. Ideal for schools, families, and corporate groups, these packages ensure a stress-free and memorable day trip."
    },
    {
      "name": "Akola Scenic Picnic Spot",
      "description": "Known for its beautiful landscapes, Woodland Escape Resort is one of the most scenic picnic spots near Akola. Surrounded by hills, greenery, and open skies, it’s the perfect destination for those seeking relaxation, photography, and quality time outdoors."
    }
  ],
  "tableData": [
    ["- Best Picnic Spot Near Akola", "- Akola Top Picnic Places"],
    ["- Akola Family Picnic Spot", "- Akola Outdoor Picnic Spot"],
    ["- Affordable Picnic Spot Akola", "- Akola Weekend Picnic"],
    ["- Akola Nature Picnic Spot", "- Akola Park Picnic Spot"],
    ["- Akola Riverside Picnic Spot", "- Akola Garden Picnic Spot"],
    ["- Akola Hill Picnic Spot", "- Akola Kids Friendly Picnic Spot"],
    ["- Akola Picnic Spot Booking", "- Akola Picnic Tour Packages"],
    ["- Akola Scenic Picnic Spot", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Scenic Picnic Spot Near Akola",
    "WhyChoosedescription": "Woodland Escape Resort is the perfect picnic destination near Akola, offering a peaceful forest setting surrounded by lush greenery. The tranquil environment provides a refreshing escape from city life, ideal for family outings, friends’ gatherings, or solo nature retreats."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Picnic Areas",
    "WhyChoosedescription": "Our resort features wide open spaces, cozy seating arrangements, and shaded areas where visitors can relax and enjoy the surroundings. Whether you want to sit by the forest trail, under the trees, or near a scenic pond, there’s a perfect spot for everyone."
  },
  {
    "WhyChooseheading": "Activities for All Ages",
    "WhyChoosedescription": "Woodland Escape Resort offers a variety of activities for every age group. Children and adults alike can enjoy forest walks, nature trails, cycling, and interactive games, making it a fun and engaging experience for the entire family."
  },
  {
    "WhyChooseheading": "Ideal for Family and Group Outings",
    "WhyChoosedescription": "Whether planning a family picnic, a school trip, or a friends’ get-together, Woodland Escape Resort provides an ideal setting. Our safe, forest-themed environment encourages bonding, relaxation, and joyful memories for groups of all sizes."
  },
  {
    "WhyChooseheading": "Relaxation in Nature",
    "WhyChoosedescription": "After exploring the forest trails and enjoying activities, visitors can unwind by the pond, read a book under the trees, or simply soak in the serene forest ambiance. It’s a perfect way to recharge and connect with nature."
  },
  {
    "WhyChooseheading": "Delicious Refreshments and Meals",
    "WhyChoosedescription": "Enjoy freshly prepared meals and snacks sourced from local ingredients. Our resort ensures that you have energizing and tasty food to complement your day out in nature, keeping everyone satisfied and happy throughout the picnic."
  },
  {
    "WhyChooseheading": "Easily Accessible from Akola",
    "WhyChoosedescription": "Located just a short drive from Akola, Woodland Escape Resort is convenient for day trips and weekend picnics. The scenic route enhances the experience, making it one of the most accessible and enjoyable picnic spots near Akola."
  }
]








  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort considered the best picnic spot near Akola?",
    answer: "Woodland Escape Resort offers a perfect mix of greenery, serene surroundings, and recreational facilities, making it one of the best picnic spots near Akola. Families and friends can enjoy a day out in nature without traveling too far from the city."
  },
  {
    question: "How far is Woodland Escape Resort from Akola?",
    answer: "The resort is located approximately 35–40 km from Akola, which takes about 1 to 1.5 hours by car. Its convenient location makes it an ideal destination for a quick family picnic or a short weekend outing."
  },
  {
    question: "What activities can we enjoy at the resort?",
    answer: "Woodland Escape Resort offers a variety of fun activities including nature walks, boating, cycling, outdoor games, and playgrounds for kids. There are also peaceful spots to relax, unwind, and enjoy the scenic views."
  },
  {
    question: "Is the resort suitable for families with children?",
    answer: "Absolutely! The resort is family-friendly with safe play areas, open lawns, and plenty of supervised activities for children. Adults can relax while the kids enjoy themselves in a secure environment."
  },
  {
    question: "Does Woodland Escape Resort provide food and picnic arrangements?",
    answer: "Yes! The resort offers freshly prepared meals, snacks, and beverages for guests. You can choose from picnic packages that include lunch, refreshments, and access to outdoor activity zones."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort?",
    answer: "Booking is simple — you can call or WhatsApp our reservation team or visit our official website to reserve your picnic date. Advance booking is recommended, especially on weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Anil & Family, Akola",
    text: "We had an amazing picnic at Woodland Escape Resort! The greenery and calm environment were perfect for a family day out. The kids loved the play areas, and the food was delicious. Truly the best picnic spot near Akola!"
  },
  {
    name: "Miss. Priya & Friends, Akola",
    text: "Woodland Escape Resort made our day trip unforgettable! Beautiful surroundings, fun activities, and friendly staff made it a perfect spot for a weekend picnic. Highly recommended for anyone near Akola."
  }
];







      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Picnic Spot Near Akola",
  "image": "https://woodlandescape.com/assets/images/best-picnic-spot-near-akola.jpg",
  "description": "Looking for the best picnic spot near Akola? Visit Woodlandescape Resort — a peaceful getaway surrounded by nature. Enjoy outdoor games, family activities, and beautiful picnic areas perfect for weekends and day trips.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1016"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/best-picnic-spot-near-akola"
  }
};





  return (
    <div>
<Helmet>
  <title>Best Picnic Spot Near Akola | Nature & Family Getaway | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan your next outing at Woodlandescape Resort — the best picnic spot near Akola. Perfect for families, kids, and couples to enjoy nature, outdoor fun, and peaceful surroundings just a short drive away." 
  />
  <meta 
    name="keywords" 
    content="Best Picnic Spot Near Akola, Akola Top Picnic Places, Akola Family Picnic Spot, Akola Outdoor Picnic Spot, Affordable Picnic Spot Akola, Akola Weekend Picnic, Akola Nature Picnic Spot, Akola Park Picnic Spot, Akola Riverside Picnic Spot, Akola Garden Picnic Spot, Akola Hill Picnic Spot, Akola Kids Friendly Picnic Spot, Akola Picnic Spot Booking, Akola Picnic Tour Packages, Akola Scenic Picnic Spot" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/9.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Bestpicnicspotnearakola;